import React from 'react';
import { IconProps } from './IconProps';

const TableIcon: React.FC<IconProps> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M2 8.25A2.25 2.25 0 0 1 4.25 6h15.5A2.25 2.25 0 0 1 22 8.25V18a2.25 2.25 0 0 1-2.25 2.25H4.25A2.25 2.25 0 0 1 2 18V8.25Z" />
    <path d="M8 6V4" />
    <path d="M16 6V4" />
    <path d="M2 12h20" />
  </svg>
);

export default TableIcon;